import {Component} from '@angular/core';
import {AbstractAction} from '../../abstract-action';

@Component({
    selector: 'vui-primary-icon-action',
    templateUrl: './primary-icon-action.component.html',
    styleUrls: ['./primary-icon-action.component.scss']
})
export class PrimaryIconActionComponent extends AbstractAction {

}
